import {
    dispatch
} from '@rematch/core';
import {
    push
} from "react-router-redux";


const initialState = {
    videoDetails: null
};

export default {
    state: initialState,
    reducers: {

        VideoDetailsState(state, payload) {
            return {
                ...state,
                videoDetails: payload
            }
        },
        clear() {
            return initialState
        }
    },

    effects: {
        clearAsync() {
            dispatch.help.clear();
        },

        setVideoDetails(payload) {
            dispatch.help.VideoDetailsState(payload)
        },
    }
}